import { message } from "antd";
import { AccountsInterestParam, PatchAccountInterestParam } from "@/Interfaces/I_AccountsInterest";
import { PayloadAction } from "@reduxjs/toolkit";
import { fetchAccountsInterest, putAccountsInterest } from "@/Axios/api/accountsInterest";
import { fetchAllMyPageTopicWithIdData } from "@/Axios/api/myPage";
import { AxiosResponse } from "axios";
import { call, put, takeLatest } from "redux-saga/effects";
import { 
  getAccountsInterest,
  getAccountInterestMyPageTopics,
  setAccountInterestMyPageTopics,
  setAccountsInterest,
  setUpdatedAccountInterest,
  updateAccountsInterest
} from "../slices/AccountsInterestSlice";


function* handleGetAccountsInterest(action: PayloadAction<AccountsInterestParam>) {
  try {
    const data: AxiosResponse = yield call(fetchAccountsInterest, action.payload)
    const accountInterest = data.data.data;
    const {pagination} = data.data;
    const payload = {
      accountInterest,
      pagination
    }
    yield put(setAccountsInterest(payload))
  } catch (e) {
    message.error({
      content: 'Fail to get account interest.',
      duration: 3,
      style: {
        marginTop: '120px',
      },
    });
  }
}

function* handleUpdateAccountInterest(action: PayloadAction<PatchAccountInterestParam>) {
  try {
    const data: AxiosResponse = yield call(putAccountsInterest, action.payload)
    if (data.status === 200) {
      message.success({
        content: 'Account status updated.',
        duration: 3,
        style: {
          marginTop: '120px',
        },
      });
    }
    yield put(setUpdatedAccountInterest(data.data))
  } catch (e) {
    message.error({
      content: 'Fail to update account Interest.',
      duration: 3,
      style: {
        marginTop: '120px',
      },
    });
  }
}

function* handleGetMyPageTopic() {
  try {
    const data: AxiosResponse = yield call(fetchAllMyPageTopicWithIdData);
    yield put(setAccountInterestMyPageTopics(data.data))
  } catch (e) {
    message.error({
      content: 'Fail to get myPage topics.',
      duration: 3,
      style: {
        marginTop: '120px',
      },
    });
  }

}

export function* watchGetAccountsInterest() {
  yield takeLatest(getAccountsInterest.type, handleGetAccountsInterest);
}

export function* watchUpdateAccountInterest() {
  yield takeLatest(updateAccountsInterest.type, handleUpdateAccountInterest);
}

export function* watchGetMyPageTopic() {
  yield takeLatest(getAccountInterestMyPageTopics.type, handleGetMyPageTopic);
}